// This file is automatically generated. Do not edit manually.

import { PartRevisionView } from "src/api/generated/erp/db/types/tables/partRevisionView";
import { PartConfigurationTemplate } from "src/api/generated/erp/db/types/tables/partConfigurationTemplate";
import { ConfiguratorInput } from "src/api/generated/io/aavo/applications/db/erp/types/configuratorInput";
import { PartConfigurationTemplateRestrictions } from "src/api/generated/io/aavo/applications/db/erp/types/partConfigurationTemplateRestrictions";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PartConfigurationTemplateEditApi {
	export async function getPartRevisionsWithoutConfigurationTemplate(args: {
		salesPartId: number;
	}): Promise<Array<PartRevisionView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/managing/configurationTemplates/edit/getPartRevisionsWithoutConfigurationTemplate",
			method: "POST",
			data: {
				salesPartId: args.salesPartId,
			},
		});
		return response as Array<PartRevisionView>;
	}

	export async function insert(args: {
		salesPartId: number;
		partRevisionId: number;
	}): Promise<PartConfigurationTemplate> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/managing/configurationTemplates/edit/insert",
			method: "POST",
			data: {
				salesPartId: args.salesPartId,
				partRevisionId: args.partRevisionId,
			},
		});
		return response as PartConfigurationTemplate;
	}

	export async function update(args: {
		partConfigurationTemplateId: number;
		configuratorInput: ConfiguratorInput;
		restrictions: PartConfigurationTemplateRestrictions;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/managing/configurationTemplates/edit/update",
			method: "POST",
			data: {
				partConfigurationTemplateId: args.partConfigurationTemplateId,
				configuratorInput: args.configuratorInput,
				restrictions: args.restrictions,
			},
		});
		return response as void;
	}

	export async function delete_(args: { partConfigurationTemplateId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/managing/configurationTemplates/edit/delete",
			method: "POST",
			data: {
				partConfigurationTemplateId: args.partConfigurationTemplateId,
			},
		});
		return response as void;
	}
}
